import { Badge, Flex, Text } from '@wyz/ui';
import { RecordValues } from '@wyz/types';
import { Trans } from '~/common/context';
import { TranslationKeys } from '~/common/types';
import { DESTOCKING_POLICY_STATUS } from '~/purchase/schemas';

interface Props {
  status: RecordValues<typeof DESTOCKING_POLICY_STATUS>;
  /** Already localised closing date, only rendered for a closed operation. */
  closedAt?: string;
}

const LABELS: Record<
  RecordValues<typeof DESTOCKING_POLICY_STATUS>,
  keyof TranslationKeys
> = {
  [DESTOCKING_POLICY_STATUS.ACTIVE]:
    'app.purchase.pricing_policy.status.active',
  [DESTOCKING_POLICY_STATUS.ENDED]:
    'app.pricing_policy.destocking.status.ended',
} as const;

const VARIANTS = {
  [DESTOCKING_POLICY_STATUS.ACTIVE]: 'success',
  [DESTOCKING_POLICY_STATUS.ENDED]: 'danger',
} as const;

const DestockingStatusCell = ({ status, closedAt }: Props) => (
  <Flex direction='column' alignItems='center' className='gap-1'>
    <Badge pill bg={VARIANTS[status]}>
      <Trans i18nKey={LABELS[status]} />
    </Badge>
    {status === DESTOCKING_POLICY_STATUS.ENDED && closedAt && (
      <Text color='secondary' heading='xxs'>
        <Trans
          i18nKey='app.pricing_policy.destocking.list.closed_since'
          values={{ date: closedAt }}
        />
      </Text>
    )}
  </Flex>
);

export default DestockingStatusCell;
